import {Component, Input, SimpleChanges} from '@angular/core';
import {Game} from "../../../models/game.class";
import {Router} from "@angular/router";
import {GameService} from "../../../services/game.service";
import {Subscription} from "rxjs";

declare var bootstrap: any;


@Component({
  selector: 'app-game-chunk',
  templateUrl: './game-chunk.component.html',
  styleUrls: ['./game-chunk.component.scss']
})
export class GameChunkComponent {
  @Input() games?: Game[];

  favouriteIds: number[] = [];
  favouritesSubs?: Subscription;

  constructor(
    private router: Router,
    private gameService: GameService
  ) {  }

  ngOnInit(){
    this.favouritesSubs?.unsubscribe();
    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })
  }


  launchGame(id:number): void {
    let chosenGame = this.games?.find(g=>g.id === id);
    if (chosenGame && chosenGame.enabled !== false){
      // chosenGame.enabled is "undefined" for Rival brands and "true" for enabled games in gamingpodium brands
      if(chosenGame.launchUrl){
        this.router.navigate(['play', chosenGame.slug])
      } else {
        this.router.navigate(['details', chosenGame.slug])
      }
    }
  }


  ngOnDestroy(){
    this.favouritesSubs?.unsubscribe();
  }



}

